export const naicsHierarchy = {
    "Agriculture, Forestry, Fishing and Hunting": {
      "Oilseed and Grain Farming": [
        { code: "111110", label: "Soybean Farming" },
        {
          code: "111120",
          label: "Oilseed (except Soybean) Farming"
        },
        { code: "111130", label: "Dry Pea and Bean Farming" },
        { code: "111140", label: "Wheat Farming" },
        { code: "111150", label: "Corn Farming" },
        { code: "111160", label: "Rice Farming" },
        {
          code: "111191",
          label: "Oilseed and Grain Combination Farming"
        },
        { code: "111199", label: "All Other Grain Farming" }
      ],
      "Vegetable and Melon Farming": [
        { code: "111211", label: "Potato Farming" },
        {
          code: "111219",
          label: "Other Vegetable (except Potato) and Melon Farming"
        }
      ],
      "Fruit and Tree Nut Farming": [
        { code: "111310", label: "Orange Groves" },
        { code: "111320", label: "Citrus (except Orange) Groves" },
        { code: "111331", label: "Apple Orchards" },
        { code: "111332", label: "Grape Vineyards" },
        { code: "111333", label: "Strawberry Farming" },
        {
          code: "111334",
          label: "Berry (except Strawberry) Farming"
        },
        { code: "111335", label: "Tree Nut Farming" },
        {
          code: "111336",
          label: "Fruit and Tree Nut Combination Farming"
        },
        { code: "111339", label: "Other Noncitrus Fruit Farming" }
      ],
      "Greenhouse, Nursery, and Floriculture Production": [
        { code: "111411", label: "Mushroom Production" },
        {
          code: "111419",
          label: "Other Food Crops Grown Under Cover"
        },
        { code: "111421", label: "Nursery and Tree Production" },
        { code: "111422", label: "Floriculture Production" }
      ],
      "Other Crop Farming": [
        { code: "111910", label: "Tobacco Farming" },
        { code: "111920", label: "Cotton Farming" },
        { code: "111930", label: "Sugarcane Farming" },
        { code: "111940", label: "Hay Farming" },
        { code: "111991", label: "Sugar Beet Farming" },
        { code: "111992", label: "Peanut Farming" },
        {
          code: "111998",
          label: "All Other Miscellaneous Crop Farming"
        }
      ],
      "Cattle Ranching and Farming": [
        {
          code: "112111",
          label: "Beef Cattle Ranching and Farming"
        },
        { code: "112112", label: "Cattle Feedlots" },
        {
          code: "112120",
          label: "Dairy Cattle and Milk Production"
        },
        {
          code: "112130",
          label: "Dual-Purpose Cattle Ranching and Farming"
        }
      ],
      "Hog and Pig Farming": [ { code: "112210", label: "Hog and Pig Farming" } ],
      "Poultry and Egg Production": [
        { code: "112310", label: "Chicken Egg Production" },
        {
          code: "112320",
          label: "Broilers and Other Meat Type Chicken Production"
        },
        { code: "112330", label: "Turkey Production" },
        { code: "112340", label: "Poultry Hatcheries" },
        { code: "112390", label: "Other Poultry Production" }
      ],
      "Sheep and Goat Farming": [
        { code: "112410", label: "Sheep Farming" },
        { code: "112420", label: "Goat Farming" }
      ],
      Aquaculture: [
        {
          code: "112511",
          label: "Finfish Farming and Fish Hatcheries"
        },
        { code: "112512", label: "Shellfish Farming" },
        { code: "112519", label: "Other Aquaculture" }
      ],
      "Other Animal Production": [
        { code: "112910", label: "Apiculture" },
        {
          code: "112920",
          label: "Horses and Other Equine Production"
        },
        {
          code: "112930",
          label: "Fur-Bearing Animal and Rabbit Production"
        },
        { code: "112990", label: "All Other Animal Production" }
      ],
      "Timber Tract Operations": [ { code: "113110", label: "Timber Tract Operations" } ],
      "Forest Nurseries and Gathering of Forest Products": [
        {
          code: "113210",
          label: "Forest Nurseries and Gathering of Forest Products"
        }
      ],
      Logging: [ { code: "113310", label: "Logging" } ],
      Fishing: [
        { code: "114111", label: "Finfish Fishing" },
        { code: "114112", label: "Shellfish Fishing" },
        { code: "114119", label: "Other Marine Fishing" }
      ],
      "Hunting and Trapping": [ { code: "114210", label: "Hunting and Trapping" } ],
      "Support Activities for Crop Production": [
        { code: "115111", label: "Cotton Ginning" },
        {
          code: "115112",
          label: "Soil Preparation, Planting, and Cultivating"
        },
        {
          code: "115113",
          label: "Crop Harvesting, Primarily by Machine"
        },
        {
          code: "115114",
          label: "Postharvest Crop Activities (except Cotton Ginning)"
        },
        {
          code: "115115",
          label: "Farm Labor Contractors and Crew Leaders"
        },
        { code: "115116", label: "Farm Management Services" }
      ],
      "Support Activities for Animal Production": [
        {
          code: "115210",
          label: "Support Activities for Animal Production"
        }
      ],
      "Support Activities for Forestry": [
        {
          code: "115310",
          label: "Support Activities for Forestry"
        }
      ]
    },
    "Mining, Quarrying, and Oil and Gas Extraction": {
      "Oil and Gas Extraction": [
        { code: "211120", label: "Crude Petroleum Extraction" },
        { code: "211130", label: "Natural Gas Extraction" }
      ],
      "Coal Mining": [
        { code: "212114", label: "Surface Coal Mining" },
        { code: "212115", label: "Underground Coal Mining" }
      ],
      "Metal Ore Mining": [
        { code: "212210", label: "Iron Ore Mining" },
        { code: "212220", label: "Gold Ore and Silver Ore Mining" },
        {
          code: "212230",
          label: "Copper, Nickel, Lead, and Zinc Mining"
        },
        { code: "212290", label: "Other Metal Ore Mining" }
      ],
      "Nonmetallic Mineral Mining and Quarrying": [
        {
          code: "212311",
          label: "Dimension Stone Mining and Quarrying"
        },
        {
          code: "212312",
          label: "Crushed and Broken Limestone Mining and Quarrying"
        },
        {
          code: "212313",
          label: "Crushed and Broken Granite Mining and Quarrying"
        },
        {
          code: "212319",
          label: "Other Crushed and Broken Stone Mining and Quarrying"
        },
        {
          code: "212321",
          label: "Construction Sand and Gravel Mining"
        },
        { code: "212322", label: "Industrial Sand Mining" },
        {
          code: "212323",
          label: "Kaolin, Clay, and Ceramic and Refractory Minerals Mining"
        },
        {
          code: "212390",
          label: "Other Nonmetallic Mineral Mining and Quarrying"
        }
      ],
      "Support Activities for Mining": [
        { code: "213111", label: "Drilling Oil and Gas Wells" },
        {
          code: "213112",
          label: "Support Activities for Oil and Gas Operations"
        },
        {
          code: "213113",
          label: "Support Activities for Coal Mining"
        },
        {
          code: "213114",
          label: "Support Activities for Metal Mining"
        },
        {
          code: "213115",
          label: "Support Activities for Nonmetallic Minerals (except Fuels) Mining"
        }
      ]
    },
    Utilities: {
      "Electric Power Generation, Transmission and Distribution": [
        { code: "221111", label: "Hydroelectric Power Generation" },
        {
          code: "221112",
          label: "Fossil Fuel Electric Power Generation"
        },
        {
          code: "221113",
          label: "Nuclear Electric Power Generation"
        },
        {
          code: "221114",
          label: "Solar Electric Power Generation"
        },
        { code: "221115", label: "Wind Electric Power Generation" },
        {
          code: "221116",
          label: "Geothermal Electric Power Generation"
        },
        {
          code: "221117",
          label: "Biomass Electric Power Generation"
        },
        {
          code: "221118",
          label: "Other Electric Power Generation"
        },
        {
          code: "221121",
          label: "Electric Bulk Power Transmission and Control"
        },
        { code: "221122", label: "Electric Power Distribution" }
      ],
      "Natural Gas Distribution": [ { code: "221210", label: "Natural Gas Distribution" } ],
      "Water, Sewage and Other Systems": [
        {
          code: "221310",
          label: "Water Supply and Irrigation Systems"
        },
        { code: "221320", label: "Sewage Treatment Facilities" },
        {
          code: "221330",
          label: "Steam and Air-Conditioning Supply"
        }
      ]
    },
    Construction: {
      "Residential Building Construction": [
        {
          code: "236115",
          label: "New Single-Family Housing Construction (except For-Sale Builders)"
        },
        {
          code: "236116",
          label: "New Multifamily Housing Construction (except For-Sale Builders)"
        },
        { code: "236117", label: "New Housing For-Sale Builders" },
        { code: "236118", label: "Residential Remodelers" }
      ],
      "Nonresidential Building Construction": [
        {
          code: "236210",
          label: "Industrial Building Construction"
        },
        {
          code: "236220",
          label: "Commercial and Institutional Building Construction"
        }
      ],
      "Utility System Construction": [
        {
          code: "237110",
          label: "Water and Sewer Line and Related Structures Construction"
        },
        {
          code: "237120",
          label: "Oil and Gas Pipeline and Related Structures Construction"
        },
        {
          code: "237130",
          label: "Power and Communication Line and Related Structures Construction"
        }
      ],
      "Land Subdivision": [ { code: "237210", label: "Land Subdivision" } ],
      "Highway, Street, and Bridge Construction": [
        {
          code: "237310",
          label: "Highway, Street, and Bridge Construction"
        }
      ],
      "Other Heavy and Civil Engineering Construction": [
        {
          code: "237990",
          label: "Other Heavy and Civil Engineering Construction"
        }
      ],
      "Foundation, Structure, and Building Exterior Contractors": [
        {
          code: "238110",
          label: "Poured Concrete Foundation and Structure Contractors"
        },
        {
          code: "238120",
          label: "Structural Steel and Precast Concrete Contractors"
        },
        { code: "238130", label: "Framing Contractors" },
        { code: "238140", label: "Masonry Contractors" },
        { code: "238150", label: "Glass and Glazing Contractors" },
        { code: "238160", label: "Roofing Contractors" },
        { code: "238170", label: "Siding Contractors" },
        {
          code: "238190",
          label: "Other Foundation, Structure, and Building Exterior Contractors"
        }
      ],
      "Building Equipment Contractors": [
        {
          code: "238210",
          label: "Electrical Contractors and Other Wiring Installation Contractors"
        },
        {
          code: "238220",
          label: "Plumbing, Heating, and Air-Conditioning Contractors"
        },
        {
          code: "238290",
          label: "Other Building Equipment Contractors"
        }
      ],
      "Building Finishing Contractors": [
        {
          code: "238310",
          label: "Drywall and Insulation Contractors"
        },
        {
          code: "238320",
          label: "Painting and Wall Covering Contractors"
        },
        { code: "238330", label: "Flooring Contractors" },
        { code: "238340", label: "Tile and Terrazzo Contractors" },
        { code: "238350", label: "Finish Carpentry Contractors" },
        {
          code: "238390",
          label: "Other Building Finishing Contractors"
        }
      ],
      "Other Specialty Trade Contractors": [
        { code: "238910", label: "Site Preparation Contractors" },
        {
          code: "238990",
          label: "All Other Specialty Trade Contractors"
        }
      ]
    },
    Manufacturing: {
      "Animal Food Manufacturing": [
        { code: "311111", label: "Dog and Cat Food Manufacturing" },
        {
          code: "311119",
          label: "Other Animal Food Manufacturing"
        }
      ],
      "Grain and Oilseed Milling": [
        { code: "311211", label: "Flour Milling" },
        { code: "311212", label: "Rice Milling" },
        { code: "311213", label: "Malt Manufacturing" },
        {
          code: "311221",
          label: "Wet Corn Milling and Starch Manufacturing"
        },
        {
          code: "311224",
          label: "Soybean and Other Oilseed Processing"
        },
        {
          code: "311225",
          label: "Fats and Oils Refining and Blending"
        },
        { code: "311230", label: "Breakfast Cereal Manufacturing" }
      ],
      "Sugar and Confectionery Product Manufacturing": [
        { code: "311313", label: "Beet Sugar Manufacturing" },
        { code: "311314", label: "Cane Sugar Manufacturing" },
        {
          code: "311340",
          label: "Nonchocolate Confectionery Manufacturing"
        },
        {
          code: "311351",
          label: "Chocolate and Confectionery Manufacturing from Cacao Beans"
        },
        {
          code: "311352",
          label: "Confectionery Manufacturing from Purchased Chocolate"
        }
      ],
      "Fruit and Vegetable Preserving and Specialty Food Manufacturing": [
        {
          code: "311411",
          label: "Frozen Fruit, Juice, and Vegetable Manufacturing"
        },
        {
          code: "311412",
          label: "Frozen Specialty Food Manufacturing"
        },
        { code: "311421", label: "Fruit and Vegetable Canning" },
        { code: "311422", label: "Specialty Canning" },
        {
          code: "311423",
          label: "Dried and Dehydrated Food Manufacturing"
        }
      ],
      "Dairy Product Manufacturing": [
        { code: "311511", label: "Fluid Milk Manufacturing" },
        { code: "311512", label: "Creamery Butter Manufacturing" },
        { code: "311513", label: "Cheese Manufacturing" },
        {
          code: "311514",
          label: "Dry, Condensed, and Evaporated Dairy Product Manufacturing"
        },
        {
          code: "311520",
          label: "Ice Cream and Frozen Dessert Manufacturing"
        }
      ],
      "Animal Slaughtering and Processing": [
        {
          code: "311611",
          label: "Animal (except Poultry) Slaughtering"
        },
        { code: "311612", label: "Meat Processed from Carcasses" },
        {
          code: "311613",
          label: "Rendering and Meat Byproduct Processing"
        },
        { code: "311615", label: "Poultry Processing" }
      ],
      "Seafood Product Preparation and Packaging": [
        {
          code: "311710",
          label: "Seafood Product Preparation and Packaging"
        }
      ],
      "Bakeries and Tortilla Manufacturing": [
        { code: "311811", label: "Retail Bakeries" },
        { code: "311812", label: "Commercial Bakeries" },
        {
          code: "311813",
          label: "Frozen Cakes, Pies, and Other Pastries Manufacturing"
        },
        {
          code: "311821",
          label: "Cookie and Cracker Manufacturing"
        },
        {
          code: "311824",
          label: "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour"
        },
        { code: "311830", label: "Tortilla Manufacturing" }
      ],
      "Other Food Manufacturing": [
        {
          code: "311911",
          label: "Roasted Nuts and Peanut Butter Manufacturing"
        },
        { code: "311919", label: "Other Snack Food Manufacturing" },
        { code: "311920", label: "Coffee and Tea Manufacturing" },
        {
          code: "311930",
          label: "Flavoring Syrup and Concentrate Manufacturing"
        },
        {
          code: "311941",
          label: "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing"
        },
        {
          code: "311942",
          label: "Spice and Extract Manufacturing"
        },
        {
          code: "311991",
          label: "Perishable Prepared Food Manufacturing"
        },
        {
          code: "311999",
          label: "All Other Miscellaneous Food Manufacturing"
        }
      ],
      "Beverage Manufacturing": [
        { code: "312111", label: "Soft Drink Manufacturing" },
        { code: "312112", label: "Bottled Water Manufacturing" },
        { code: "312113", label: "Ice Manufacturing" },
        { code: "312120", label: "Breweries" },
        { code: "312130", label: "Wineries" },
        { code: "312140", label: "Distilleries" }
      ],
      "Tobacco Manufacturing": [ { code: "312230", label: "Tobacco Manufacturing" } ],
      "Fiber, Yarn, and Thread Mills": [
        { code: "313110", label: "Fiber, Yarn, and Thread Mills" }
      ],
      "Fabric Mills": [
        { code: "313210", label: "Broadwoven Fabric Mills" },
        {
          code: "313220",
          label: "Narrow Fabric Mills and Schiffli Machine Embroidery"
        },
        { code: "313230", label: "Nonwoven Fabric Mills" },
        { code: "313240", label: "Knit Fabric Mills" }
      ],
      "Textile and Fabric Finishing and Fabric Coating Mills": [
        {
          code: "313310",
          label: "Textile and Fabric Finishing Mills"
        },
        { code: "313320", label: "Fabric Coating Mills" }
      ],
      "Textile Furnishings Mills": [
        { code: "314110", label: "Carpet and Rug Mills" },
        { code: "314120", label: "Curtain and Linen Mills" }
      ],
      "Other Textile Product Mills": [
        { code: "314910", label: "Textile Bag and Canvas Mills" },
        {
          code: "314994",
          label: "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills"
        },
        {
          code: "314999",
          label: "All Other Miscellaneous Textile Product Mills"
        }
      ],
      "Apparel Knitting Mills": [ { code: "315120", label: "Apparel Knitting Mills" } ],
      "Cut and Sew Apparel Manufacturing": [
        {
          code: "315210",
          label: "Cut and Sew Apparel Contractors"
        },
        {
          code: "315250",
          label: "Cut and Sew Apparel Manufacturing (except Contractors)"
        }
      ],
      "Apparel Accessories and Other Apparel Manufacturing": [
        {
          code: "315990",
          label: "Apparel Accessories and Other Apparel Manufacturing"
        }
      ],
      "Leather and Hide Tanning and Finishing": [
        {
          code: "316110",
          label: "Leather and Hide Tanning and Finishing"
        }
      ],
      "Footwear Manufacturing": [ { code: "316210", label: "Footwear Manufacturing" } ],
      "Other Leather and Allied Product Manufacturing": [
        {
          code: "316990",
          label: "Other Leather and Allied Product Manufacturing"
        }
      ],
      "Sawmills and Wood Preservation": [
        { code: "321113", label: "Sawmills" },
        { code: "321114", label: "Wood Preservation" }
      ],
      "Veneer, Plywood, and Engineered Wood Product Manufacturing": [
        {
          code: "321211",
          label: "Hardwood Veneer and Plywood Manufacturing"
        },
        {
          code: "321212",
          label: "Softwood Veneer and Plywood Manufacturing"
        },
        {
          code: "321215",
          label: "Engineered Wood Member Manufacturing"
        },
        {
          code: "321219",
          label: "Reconstituted Wood Product Manufacturing"
        }
      ],
      "Other Wood Product Manufacturing": [
        {
          code: "321911",
          label: "Wood Window and Door Manufacturing"
        },
        {
          code: "321912",
          label: "Cut Stock, Resawing Lumber, and Planing"
        },
        {
          code: "321918",
          label: "Other Millwork (including Flooring)"
        },
        {
          code: "321920",
          label: "Wood Container and Pallet Manufacturing"
        },
        {
          code: "321991",
          label: "Manufactured Home (Mobile Home) Manufacturing"
        },
        {
          code: "321992",
          label: "Prefabricated Wood Building Manufacturing"
        },
        {
          code: "321999",
          label: "All Other Miscellaneous Wood Product Manufacturing"
        }
      ],
      "Pulp, Paper, and Paperboard Mills": [
        { code: "322110", label: "Pulp Mills" },
        { code: "322120", label: "Paper Mills" },
        { code: "322130", label: "Paperboard Mills" }
      ],
      "Converted Paper Product Manufacturing": [
        {
          code: "322211",
          label: "Corrugated and Solid Fiber Box Manufacturing"
        },
        {
          code: "322212",
          label: "Folding Paperboard Box Manufacturing"
        },
        {
          code: "322219",
          label: "Other Paperboard Container Manufacturing"
        },
        {
          code: "322220",
          label: "Paper Bag and Coated and Treated Paper Manufacturing"
        },
        {
          code: "322230",
          label: "Stationery Product Manufacturing"
        },
        {
          code: "322291",
          label: "Sanitary Paper Product Manufacturing"
        },
        {
          code: "322299",
          label: "All Other Converted Paper Product Manufacturing"
        }
      ],
      "Printing and Related Support Activities": [
        {
          code: "323111",
          label: "Commercial Printing (except Screen and Books)"
        },
        { code: "323113", label: "Commercial Screen Printing" },
        { code: "323117", label: "Books Printing" },
        {
          code: "323120",
          label: "Support Activities for Printing"
        }
      ],
      "Petroleum and Coal Products Manufacturing": [
        { code: "324110", label: "Petroleum Refineries" },
        {
          code: "324121",
          label: "Asphalt Paving Mixture and Block Manufacturing"
        },
        {
          code: "324122",
          label: "Asphalt Shingle and Coating Materials Manufacturing"
        },
        {
          code: "324191",
          label: "Petroleum Lubricating Oil and Grease Manufacturing"
        },
        {
          code: "324199",
          label: "All Other Petroleum and Coal Products Manufacturing"
        }
      ],
      "Basic Chemical Manufacturing": [
        { code: "325110", label: "Petrochemical Manufacturing" },
        { code: "325120", label: "Industrial Gas Manufacturing" },
        {
          code: "325130",
          label: "Synthetic Dye and Pigment Manufacturing"
        },
        {
          code: "325180",
          label: "Other Basic Inorganic Chemical Manufacturing"
        },
        { code: "325193", label: "Ethyl Alcohol Manufacturing" },
        {
          code: "325194",
          label: "Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing"
        },
        {
          code: "325199",
          label: "All Other Basic Organic Chemical Manufacturing"
        }
      ],
      "Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing": [
        {
          code: "325211",
          label: "Plastics Material and Resin Manufacturing"
        },
        { code: "325212", label: "Synthetic Rubber Manufacturing" },
        {
          code: "325220",
          label: "Artificial and Synthetic Fibers and Filaments Manufacturing"
        }
      ],
      "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing": [
        {
          code: "325311",
          label: "Nitrogenous Fertilizer Manufacturing"
        },
        {
          code: "325312",
          label: "Phosphatic Fertilizer Manufacturing"
        },
        {
          code: "325314",
          label: "Fertilizer (Mixing Only) Manufacturing"
        },
        { code: "325315", label: "Compost Manufacturing" },
        {
          code: "325320",
          label: "Pesticide and Other Agricultural Chemical Manufacturing"
        }
      ],
      "Pharmaceutical and Medicine Manufacturing": [
        {
          code: "325411",
          label: "Medicinal and Botanical Manufacturing"
        },
        {
          code: "325412",
          label: "Pharmaceutical Preparation Manufacturing"
        },
        {
          code: "325413",
          label: "In-Vitro Diagnostic Substance Manufacturing"
        },
        {
          code: "325414",
          label: "Biological Product (except Diagnostic) Manufacturing"
        }
      ],
      "Paint, Coating, and Adhesive Manufacturing": [
        {
          code: "325510",
          label: "Paint and Coating Manufacturing"
        },
        { code: "325520", label: "Adhesive Manufacturing" }
      ],
      "Soap, Cleaning Compound, and Toilet Preparation Manufacturing": [
        {
          code: "325611",
          label: "Soap and Other Detergent Manufacturing"
        },
        {
          code: "325612",
          label: "Polish and Other Sanitation Good Manufacturing"
        },
        {
          code: "325613",
          label: "Surface Active Agent Manufacturing"
        },
        {
          code: "325620",
          label: "Toilet Preparation Manufacturing"
        }
      ],
      "Other Chemical Product and Preparation Manufacturing": [
        { code: "325910", label: "Printing Ink Manufacturing" },
        { code: "325920", label: "Explosives Manufacturing" },
        {
          code: "325991",
          label: "Custom Compounding of Purchased Resins"
        },
        {
          code: "325992",
          label: "Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing"
        },
        {
          code: "325998",
          label: "All Other Miscellaneous Chemical Product and Preparation Manufacturing"
        }
      ],
      "Plastics Product Manufacturing": [
        {
          code: "326111",
          label: "Plastics Bag and Pouch Manufacturing"
        },
        {
          code: "326112",
          label: "Plastics Packaging Film and Sheet (including Laminated) Manufacturing"
        },
        {
          code: "326113",
          label: "Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing"
        },
        {
          code: "326121",
          label: "Unlaminated Plastics Profile Shape Manufacturing"
        },
        {
          code: "326122",
          label: "Plastics Pipe and Pipe Fitting Manufacturing"
        },
        {
          code: "326130",
          label: "Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing"
        },
        {
          code: "326140",
          label: "Polystyrene Foam Product Manufacturing"
        },
        {
          code: "326150",
          label: "Urethane and Other Foam Product (except Polystyrene) Manufacturing"
        },
        { code: "326160", label: "Plastics Bottle Manufacturing" },
        {
          code: "326191",
          label: "Plastics Plumbing Fixture Manufacturing"
        },
        {
          code: "326199",
          label: "All Other Plastics Product Manufacturing"
        }
      ],
      "Rubber Product Manufacturing": [
        {
          code: "326211",
          label: "Tire Manufacturing (except Retreading)"
        },
        { code: "326212", label: "Tire Retreading" },
        {
          code: "326220",
          label: "Rubber and Plastics Hoses and Belting Manufacturing"
        },
        {
          code: "326291",
          label: "Rubber Product Manufacturing for Mechanical Use"
        },
        {
          code: "326299",
          label: "All Other Rubber Product Manufacturing"
        }
      ],
      "Clay Product and Refractory Manufacturing": [
        {
          code: "327110",
          label: "Pottery, Ceramics, and Plumbing Fixture Manufacturing"
        },
        {
          code: "327120",
          label: "Clay Building Material and Refractories Manufacturing"
        }
      ],
      "Glass and Glass Product Manufacturing": [
        { code: "327211", label: "Flat Glass Manufacturing" },
        {
          code: "327212",
          label: "Other Pressed and Blown Glass and Glassware Manufacturing"
        },
        { code: "327213", label: "Glass Container Manufacturing" },
        {
          code: "327215",
          label: "Glass Product Manufacturing Made of Purchased Glass"
        }
      ],
      "Cement and Concrete Product Manufacturing": [
        { code: "327310", label: "Cement Manufacturing" },
        {
          code: "327320",
          label: "Ready-Mix Concrete Manufacturing"
        },
        {
          code: "327331",
          label: "Concrete Block and Brick Manufacturing"
        },
        { code: "327332", label: "Concrete Pipe Manufacturing" },
        {
          code: "327390",
          label: "Other Concrete Product Manufacturing"
        }
      ],
      "Lime and Gypsum Product Manufacturing": [
        { code: "327410", label: "Lime Manufacturing" },
        { code: "327420", label: "Gypsum Product Manufacturing" }
      ],
      "Other Nonmetallic Mineral Product Manufacturing": [
        { code: "327910", label: "Abrasive Product Manufacturing" },
        {
          code: "327991",
          label: "Cut Stone and Stone Product Manufacturing"
        },
        {
          code: "327992",
          label: "Ground or Treated Mineral and Earth Manufacturing"
        },
        { code: "327993", label: "Mineral Wool Manufacturing" },
        {
          code: "327999",
          label: "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing"
        }
      ],
      "Iron and Steel Mills and Ferroalloy Manufacturing": [
        {
          code: "331110",
          label: "Iron and Steel Mills and Ferroalloy Manufacturing"
        }
      ],
      "Steel Product Manufacturing from Purchased Steel": [
        {
          code: "331210",
          label: "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel"
        },
        {
          code: "331221",
          label: "Rolled Steel Shape Manufacturing"
        },
        { code: "331222", label: "Steel Wire Drawing" }
      ],
      "Alumina and Aluminum Production and Processing": [
        {
          code: "331313",
          label: "Alumina Refining and Primary Aluminum Production"
        },
        {
          code: "331314",
          label: "Secondary Smelting and Alloying of Aluminum"
        },
        {
          code: "331315",
          label: "Aluminum Sheet, Plate, and Foil Manufacturing"
        },
        {
          code: "331318",
          label: "Other Aluminum Rolling, Drawing, and Extruding"
        }
      ],
      "Nonferrous Metal (except Aluminum) Production and Processing": [
        {
          code: "331410",
          label: "Nonferrous Metal (except Aluminum) Smelting and Refining"
        },
        {
          code: "331420",
          label: "Copper Rolling, Drawing, Extruding, and Alloying"
        },
        {
          code: "331491",
          label: "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding"
        },
        {
          code: "331492",
          label: "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)"
        }
      ],
      Foundries: [
        { code: "331511", label: "Iron Foundries" },
        { code: "331512", label: "Steel Investment Foundries" },
        {
          code: "331513",
          label: "Steel Foundries (except Investment)"
        },
        {
          code: "331523",
          label: "Nonferrous Metal Die-Casting Foundries"
        },
        {
          code: "331524",
          label: "Aluminum Foundries (except Die-Casting)"
        },
        {
          code: "331529",
          label: "Other Nonferrous Metal Foundries (except Die-Casting)"
        }
      ],
      "Forging and Stamping": [
        { code: "332111", label: "Iron and Steel Forging" },
        { code: "332112", label: "Nonferrous Forging" },
        { code: "332114", label: "Custom Roll Forming" },
        {
          code: "332117",
          label: "Powder Metallurgy Part Manufacturing"
        },
        {
          code: "332119",
          label: "Metal Crown, Closure, and Other Metal Stamping (except Automotive)"
        }
      ],
      "Cutlery and Handtool Manufacturing": [
        {
          code: "332215",
          label: "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing"
        },
        {
          code: "332216",
          label: "Saw Blade and Handtool Manufacturing"
        }
      ],
      "Architectural and Structural Metals Manufacturing": [
        {
          code: "332311",
          label: "Prefabricated Metal Building and Component Manufacturing"
        },
        {
          code: "332312",
          label: "Fabricated Structural Metal Manufacturing"
        },
        { code: "332313", label: "Plate Work Manufacturing" },
        {
          code: "332321",
          label: "Metal Window and Door Manufacturing"
        },
        { code: "332322", label: "Sheet Metal Work Manufacturing" },
        {
          code: "332323",
          label: "Ornamental and Architectural Metal Work Manufacturing"
        }
      ],
      "Boiler, Tank, and Shipping Container Manufacturing": [
        {
          code: "332410",
          label: "Power Boiler and Heat Exchanger Manufacturing"
        },
        {
          code: "332420",
          label: "Metal Tank (Heavy Gauge) Manufacturing"
        },
        { code: "332431", label: "Metal Can Manufacturing" },
        {
          code: "332439",
          label: "Other Metal Container Manufacturing"
        }
      ],
      "Hardware Manufacturing": [ { code: "332510", label: "Hardware Manufacturing" } ],
      "Spring and Wire Product Manufacturing": [
        { code: "332613", label: "Spring Manufacturing" },
        {
          code: "332618",
          label: "Other Fabricated Wire Product Manufacturing"
        }
      ],
      "Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing": [
        { code: "332710", label: "Machine Shops" },
        {
          code: "332721",
          label: "Precision Turned Product Manufacturing"
        },
        {
          code: "332722",
          label: "Bolt, Nut, Screw, Rivet, and Washer Manufacturing"
        }
      ],
      "Coating, Engraving, Heat Treating, and Allied Activities": [
        { code: "332811", label: "Metal Heat Treating" },
        {
          code: "332812",
          label: "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers"
        },
        {
          code: "332813",
          label: "Electroplating, Plating, Polishing, Anodizing, and Coloring"
        }
      ],
      "Other Fabricated Metal Product Manufacturing": [
        { code: "332911", label: "Industrial Valve Manufacturing" },
        {
          code: "332912",
          label: "Fluid Power Valve and Hose Fitting Manufacturing"
        },
        {
          code: "332913",
          label: "Plumbing Fixture Fitting and Trim Manufacturing"
        },
        {
          code: "332919",
          label: "Other Metal Valve and Pipe Fitting Manufacturing"
        },
        {
          code: "332991",
          label: "Ball and Roller Bearing Manufacturing"
        },
        {
          code: "332992",
          label: "Small Arms Ammunition Manufacturing"
        },
        {
          code: "332993",
          label: "Ammunition (except Small Arms) Manufacturing"
        },
        {
          code: "332994",
          label: "Small Arms, Ordnance, and Ordnance Accessories Manufacturing"
        },
        {
          code: "332996",
          label: "Fabricated Pipe and Pipe Fitting Manufacturing"
        },
        {
          code: "332999",
          label: "All Other Miscellaneous Fabricated Metal Product Manufacturing"
        }
      ],
      "Agriculture, Construction, and Mining Machinery Manufacturing": [
        {
          code: "333111",
          label: "Farm Machinery and Equipment Manufacturing"
        },
        {
          code: "333112",
          label: "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing"
        },
        {
          code: "333120",
          label: "Construction Machinery Manufacturing"
        },
        {
          code: "333131",
          label: "Mining Machinery and Equipment Manufacturing"
        },
        {
          code: "333132",
          label: "Oil and Gas Field Machinery and Equipment Manufacturing"
        }
      ],
      "Industrial Machinery Manufacturing": [
        {
          code: "333241",
          label: "Food Product Machinery Manufacturing"
        },
        {
          code: "333242",
          label: "Semiconductor Machinery Manufacturing"
        },
        {
          code: "333243",
          label: "Sawmill, Woodworking, and Paper Machinery Manufacturing"
        },
        {
          code: "333248",
          label: "All Other Industrial Machinery Manufacturing"
        }
      ],
      "Commercial and Service Industry Machinery Manufacturing": [
        {
          code: "333310",
          label: "Commercial and Service Industry Machinery Manufacturing"
        }
      ],
      "Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing": [
        {
          code: "333413",
          label: "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing"
        },
        {
          code: "333414",
          label: "Heating Equipment (except Warm Air Furnaces) Manufacturing"
        },
        {
          code: "333415",
          label: "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing"
        }
      ],
      "Metalworking Machinery Manufacturing": [
        { code: "333511", label: "Industrial Mold Manufacturing" },
        {
          code: "333514",
          label: "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing"
        },
        {
          code: "333515",
          label: "Cutting Tool and Machine Tool Accessory Manufacturing"
        },
        { code: "333517", label: "Machine Tool Manufacturing" },
        {
          code: "333519",
          label: "Rolling Mill and Other Metalworking Machinery Manufacturing"
        }
      ],
      "Engine, Turbine, and Power Transmission Equipment Manufacturing": [
        {
          code: "333611",
          label: "Turbine and Turbine Generator Set Units Manufacturing"
        },
        {
          code: "333612",
          label: "Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing"
        },
        {
          code: "333613",
          label: "Mechanical Power Transmission Equipment Manufacturing"
        },
        {
          code: "333618",
          label: "Other Engine Equipment Manufacturing"
        }
      ],
      "Other General Purpose Machinery Manufacturing": [
        {
          code: "333912",
          label: "Air and Gas Compressor Manufacturing"
        },
        {
          code: "333914",
          label: "Measuring, Dispensing, and Other Pumping Equipment Manufacturing"
        },
        {
          code: "333921",
          label: "Elevator and Moving Stairway Manufacturing"
        },
        {
          code: "333922",
          label: "Conveyor and Conveying Equipment Manufacturing"
        },
        {
          code: "333923",
          label: "Overhead Traveling Crane, Hoist, and Monorail System Manufacturing"
        },
        {
          code: "333924",
          label: "Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing"
        },
        {
          code: "333991",
          label: "Power-Driven Handtool Manufacturing"
        },
        {
          code: "333992",
          label: "Welding and Soldering Equipment Manufacturing"
        },
        {
          code: "333993",
          label: "Packaging Machinery Manufacturing"
        },
        {
          code: "333994",
          label: "Industrial Process Furnace and Oven Manufacturing"
        },
        {
          code: "333995",
          label: "Fluid Power Cylinder and Actuator Manufacturing"
        },
        {
          code: "333996",
          label: "Fluid Power Pump and Motor Manufacturing"
        },
        {
          code: "333998",
          label: "All Other Miscellaneous General Purpose Machinery Manufacturing"
        }
      ],
      "Computer and Peripheral Equipment Manufacturing": [
        {
          code: "334111",
          label: "Electronic Computer Manufacturing"
        },
        {
          code: "334112",
          label: "Computer Storage Device Manufacturing"
        },
        {
          code: "334118",
          label: "Computer Terminal and Other Computer Peripheral Equipment Manufacturing"
        }
      ],
      "Communications Equipment Manufacturing": [
        {
          code: "334210",
          label: "Telephone Apparatus Manufacturing"
        },
        {
          code: "334220",
          label: "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing"
        },
        {
          code: "334290",
          label: "Other Communications Equipment Manufacturing"
        }
      ],
      "Audio and Video Equipment Manufacturing": [
        {
          code: "334310",
          label: "Audio and Video Equipment Manufacturing"
        }
      ],
      "Semiconductor and Other Electronic Component Manufacturing": [
        {
          code: "334412",
          label: "Bare Printed Circuit Board Manufacturing"
        },
        {
          code: "334413",
          label: "Semiconductor and Related Device Manufacturing"
        },
        {
          code: "334416",
          label: "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing"
        },
        {
          code: "334417",
          label: "Electronic Connector Manufacturing"
        },
        {
          code: "334418",
          label: "Printed Circuit Assembly (Electronic Assembly) Manufacturing"
        },
        {
          code: "334419",
          label: "Other Electronic Component Manufacturing"
        }
      ],
      "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing": [
        {
          code: "334510",
          label: "Electromedical and Electrotherapeutic Apparatus Manufacturing"
        },
        {
          code: "334511",
          label: "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing"
        },
        {
          code: "334512",
          label: "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use"
        },
        {
          code: "334513",
          label: "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables"
        },
        {
          code: "334514",
          label: "Totalizing Fluid Meter and Counting Device Manufacturing"
        },
        {
          code: "334515",
          label: "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals"
        },
        {
          code: "334516",
          label: "Analytical Laboratory Instrument Manufacturing"
        },
        {
          code: "334517",
          label: "Irradiation Apparatus Manufacturing"
        },
        {
          code: "334519",
          label: "Other Measuring and Controlling Device Manufacturing"
        }
      ],
      "Manufacturing and Reproducing Magnetic and Optical Media": [
        {
          code: "334610",
          label: "Manufacturing and Reproducing Magnetic and Optical Media"
        }
      ],
      "Electric Lighting Equipment Manufacturing": [
        {
          code: "335131",
          label: "Residential Electric Lighting Fixture Manufacturing"
        },
        {
          code: "335132",
          label: "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing"
        },
        {
          code: "335139",
          label: "Electric Lamp Bulb and Other Lighting Equipment Manufacturing"
        }
      ],
      "Household Appliance Manufacturing": [
        {
          code: "335210",
          label: "Small Electrical Appliance Manufacturing"
        },
        {
          code: "335220",
          label: "Major Household Appliance Manufacturing"
        }
      ],
      "Electrical Equipment Manufacturing": [
        {
          code: "335311",
          label: "Power, Distribution, and Specialty Transformer Manufacturing"
        },
        {
          code: "335312",
          label: "Motor and Generator Manufacturing"
        },
        {
          code: "335313",
          label: "Switchgear and Switchboard Apparatus Manufacturing"
        },
        {
          code: "335314",
          label: "Relay and Industrial Control Manufacturing"
        }
      ],
      "Other Electrical Equipment and Component Manufacturing": [
        { code: "335910", label: "Battery Manufacturing" },
        {
          code: "335921",
          label: "Fiber Optic Cable Manufacturing"
        },
        {
          code: "335929",
          label: "Other Communication and Energy Wire Manufacturing"
        },
        {
          code: "335931",
          label: "Current-Carrying Wiring Device Manufacturing"
        },
        {
          code: "335932",
          label: "Noncurrent-Carrying Wiring Device Manufacturing"
        },
        {
          code: "335991",
          label: "Carbon and Graphite Product Manufacturing"
        },
        {
          code: "335999",
          label: "All Other Miscellaneous Electrical Equipment and Component Manufacturing"
        }
      ],
      "Motor Vehicle Manufacturing": [
        {
          code: "336110",
          label: "Automobile and Light Duty Motor Vehicle Manufacturing"
        },
        { code: "336120", label: "Heavy Duty Truck Manufacturing" }
      ],
      "Motor Vehicle Body and Trailer Manufacturing": [
        {
          code: "336211",
          label: "Motor Vehicle Body Manufacturing"
        },
        { code: "336212", label: "Truck Trailer Manufacturing" },
        { code: "336213", label: "Motor Home Manufacturing" },
        {
          code: "336214",
          label: "Travel Trailer and Camper Manufacturing"
        }
      ],
      "Motor Vehicle Parts Manufacturing": [
        {
          code: "336310",
          label: "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing"
        },
        {
          code: "336320",
          label: "Motor Vehicle Electrical and Electronic Equipment Manufacturing"
        },
        {
          code: "336330",
          label: "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing"
        },
        {
          code: "336340",
          label: "Motor Vehicle Brake System Manufacturing"
        },
        {
          code: "336350",
          label: "Motor Vehicle Transmission and Power Train Parts Manufacturing"
        },
        {
          code: "336360",
          label: "Motor Vehicle Seating and Interior Trim Manufacturing"
        },
        { code: "336370", label: "Motor Vehicle Metal Stamping" },
        {
          code: "336390",
          label: "Other Motor Vehicle Parts Manufacturing"
        }
      ],
      "Aerospace Product and Parts Manufacturing": [
        { code: "336411", label: "Aircraft Manufacturing" },
        {
          code: "336412",
          label: "Aircraft Engine and Engine Parts Manufacturing"
        },
        {
          code: "336413",
          label: "Other Aircraft Parts and Auxiliary Equipment Manufacturing"
        },
        {
          code: "336414",
          label: "Guided Missile and Space Vehicle Manufacturing"
        },
        {
          code: "336415",
          label: "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing"
        },
        {
          code: "336419",
          label: "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing"
        }
      ],
      "Railroad Rolling Stock Manufacturing": [
        {
          code: "336510",
          label: "Railroad Rolling Stock Manufacturing"
        }
      ],
      "Ship and Boat Building": [
        { code: "336611", label: "Ship Building and Repairing" },
        { code: "336612", label: "Boat Building" }
      ],
      "Other Transportation Equipment Manufacturing": [
        {
          code: "336991",
          label: "Motorcycle, Bicycle, and Parts Manufacturing"
        },
        {
          code: "336992",
          label: "Military Armored Vehicle, Tank, and Tank Component Manufacturing"
        },
        {
          code: "336999",
          label: "All Other Transportation Equipment Manufacturing"
        }
      ],
      "Household and Institutional Furniture and Kitchen Cabinet Manufacturing": [
        {
          code: "337110",
          label: "Wood Kitchen Cabinet and Countertop Manufacturing"
        },
        {
          code: "337121",
          label: "Upholstered Household Furniture Manufacturing"
        },
        {
          code: "337122",
          label: "Nonupholstered Wood Household Furniture Manufacturing"
        },
        {
          code: "337126",
          label: "Household Furniture (except Wood and Upholstered) Manufacturing"
        },
        {
          code: "337127",
          label: "Institutional Furniture Manufacturing"
        }
      ],
      "Office Furniture (including Fixtures) Manufacturing": [
        {
          code: "337211",
          label: "Wood Office Furniture Manufacturing"
        },
        {
          code: "337212",
          label: "Custom Architectural Woodwork and Millwork Manufacturing"
        },
        {
          code: "337214",
          label: "Office Furniture (except Wood) Manufacturing"
        },
        {
          code: "337215",
          label: "Showcase, Partition, Shelving, and Locker Manufacturing"
        }
      ],
      "Other Furniture Related Product Manufacturing": [
        { code: "337910", label: "Mattress Manufacturing" },
        { code: "337920", label: "Blind and Shade Manufacturing" }
      ],
      "Medical Equipment and Supplies Manufacturing": [
        {
          code: "339112",
          label: "Surgical and Medical Instrument Manufacturing"
        },
        {
          code: "339113",
          label: "Surgical Appliance and Supplies Manufacturing"
        },
        {
          code: "339114",
          label: "Dental Equipment and Supplies Manufacturing"
        },
        { code: "339115", label: "Ophthalmic Goods Manufacturing" },
        { code: "339116", label: "Dental Laboratories" }
      ],
      "Other Miscellaneous Manufacturing": [
        {
          code: "339910",
          label: "Jewelry and Silverware Manufacturing"
        },
        {
          code: "339920",
          label: "Sporting and Athletic Goods Manufacturing"
        },
        {
          code: "339930",
          label: "Doll, Toy, and Game Manufacturing"
        },
        {
          code: "339940",
          label: "Office Supplies (except Paper) Manufacturing"
        },
        { code: "339950", label: "Sign Manufacturing" },
        {
          code: "339991",
          label: "Gasket, Packing, and Sealing Device Manufacturing"
        },
        {
          code: "339992",
          label: "Musical Instrument Manufacturing"
        },
        {
          code: "339993",
          label: "Fastener, Button, Needle, and Pin Manufacturing"
        },
        {
          code: "339994",
          label: "Broom, Brush, and Mop Manufacturing"
        },
        { code: "339995", label: "Burial Casket Manufacturing" },
        {
          code: "339999",
          label: "All Other Miscellaneous Manufacturing"
        }
      ]
    },
    "Wholesale Trade": {
      "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers": [
        {
          code: "423110",
          label: "Automobile and Other Motor Vehicle Merchant Wholesalers"
        },
        {
          code: "423120",
          label: "Motor Vehicle Supplies and New Parts Merchant Wholesalers"
        },
        {
          code: "423130",
          label: "Tire and Tube Merchant Wholesalers"
        },
        {
          code: "423140",
          label: "Motor Vehicle Parts (Used) Merchant Wholesalers"
        }
      ],
      "Furniture and Home Furnishing Merchant Wholesalers": [
        { code: "423210", label: "Furniture Merchant Wholesalers" },
        {
          code: "423220",
          label: "Home Furnishing Merchant Wholesalers"
        }
      ],
      "Lumber and Other Construction Materials Merchant Wholesalers": [
        {
          code: "423310",
          label: "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers"
        },
        {
          code: "423320",
          label: "Brick, Stone, and Related Construction Material Merchant Wholesalers"
        },
        {
          code: "423330",
          label: "Roofing, Siding, and Insulation Material Merchant Wholesalers"
        },
        {
          code: "423390",
          label: "Other Construction Material Merchant Wholesalers"
        }
      ],
      "Professional and Commercial Equipment and Supplies Merchant Wholesalers": [
        {
          code: "423410",
          label: "Photographic Equipment and Supplies Merchant Wholesalers"
        },
        {
          code: "423420",
          label: "Office Equipment Merchant Wholesalers"
        },
        {
          code: "423430",
          label: "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers"
        },
        {
          code: "423440",
          label: "Other Commercial Equipment Merchant Wholesalers"
        },
        {
          code: "423450",
          label: "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers"
        },
        {
          code: "423460",
          label: "Ophthalmic Goods Merchant Wholesalers"
        },
        {
          code: "423490",
          label: "Other Professional Equipment and Supplies Merchant Wholesalers"
        }
      ],
      "Metal and Mineral (except Petroleum) Merchant Wholesalers": [
        {
          code: "423510",
          label: "Metal Service Centers and Other Metal Merchant Wholesalers"
        },
        {
          code: "423520",
          label: "Coal and Other Mineral and Ore Merchant Wholesalers"
        }
      ],
      "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers": [
        {
          code: "423610",
          label: "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers"
        },
        {
          code: "423620",
          label: "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers"
        },
        {
          code: "423690",
          label: "Other Electronic Parts and Equipment Merchant Wholesalers"
        }
      ],
      "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers": [
        { code: "423710", label: "Hardware Merchant Wholesalers" },
        {
          code: "423720",
          label: "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers"
        },
        {
          code: "423730",
          label: "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers"
        },
        {
          code: "423740",
          label: "Refrigeration Equipment and Supplies Merchant Wholesalers"
        }
      ],
      "Machinery, Equipment, and Supplies Merchant Wholesalers": [
        {
          code: "423810",
          label: "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers"
        },
        {
          code: "423820",
          label: "Farm and Garden Machinery and Equipment Merchant Wholesalers"
        },
        {
          code: "423830",
          label: "Industrial Machinery and Equipment Merchant Wholesalers"
        },
        {
          code: "423840",
          label: "Industrial Supplies Merchant Wholesalers"
        },
        {
          code: "423850",
          label: "Service Establishment Equipment and Supplies Merchant Wholesalers"
        },
        {
          code: "423860",
          label: "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers"
        }
      ],
      "Miscellaneous Durable Goods Merchant Wholesalers": [
        {
          code: "423910",
          label: "Sporting and Recreational Goods and Supplies Merchant Wholesalers"
        },
        {
          code: "423920",
          label: "Toy and Hobby Goods and Supplies Merchant Wholesalers"
        },
        {
          code: "423930",
          label: "Recyclable Material Merchant Wholesalers"
        },
        {
          code: "423940",
          label: "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers"
        },
        {
          code: "423990",
          label: "Other Miscellaneous Durable Goods Merchant Wholesalers"
        }
      ],
      "Paper and Paper Product Merchant Wholesalers": [
        {
          code: "424110",
          label: "Printing and Writing Paper Merchant Wholesalers"
        },
        {
          code: "424120",
          label: "Stationery and Office Supplies Merchant Wholesalers"
        },
        {
          code: "424130",
          label: "Industrial and Personal Service Paper Merchant Wholesalers"
        }
      ],
      "Drugs and Druggists' Sundries Merchant Wholesalers": [
        {
          code: "424210",
          label: "Drugs and Druggists' Sundries Merchant Wholesalers"
        }
      ],
      "Apparel, Piece Goods, and Notions Merchant Wholesalers": [
        {
          code: "424310",
          label: "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers"
        },
        { code: "424340", label: "Footwear Merchant Wholesalers" },
        {
          code: "424350",
          label: "Clothing and Clothing Accessories Merchant Wholesalers"
        }
      ],
      "Grocery and Related Product Merchant Wholesalers": [
        {
          code: "424410",
          label: "General Line Grocery Merchant Wholesalers"
        },
        {
          code: "424420",
          label: "Packaged Frozen Food Merchant Wholesalers"
        },
        {
          code: "424430",
          label: "Dairy Product (except Dried or Canned) Merchant Wholesalers"
        },
        {
          code: "424440",
          label: "Poultry and Poultry Product Merchant Wholesalers"
        },
        {
          code: "424450",
          label: "Confectionery Merchant Wholesalers"
        },
        {
          code: "424460",
          label: "Fish and Seafood Merchant Wholesalers"
        },
        {
          code: "424470",
          label: "Meat and Meat Product Merchant Wholesalers"
        },
        {
          code: "424480",
          label: "Fresh Fruit and Vegetable Merchant Wholesalers"
        },
        {
          code: "424490",
          label: "Other Grocery and Related Products Merchant Wholesalers"
        }
      ],
      "Farm Product Raw Material Merchant Wholesalers": [
        {
          code: "424510",
          label: "Grain and Field Bean Merchant Wholesalers"
        },
        { code: "424520", label: "Livestock Merchant Wholesalers" },
        {
          code: "424590",
          label: "Other Farm Product Raw Material Merchant Wholesalers"
        }
      ],
      "Chemical and Allied Products Merchant Wholesalers": [
        {
          code: "424610",
          label: "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers"
        },
        {
          code: "424690",
          label: "Other Chemical and Allied Products Merchant Wholesalers"
        }
      ],
      "Petroleum and Petroleum Products Merchant Wholesalers": [
        {
          code: "424710",
          label: "Petroleum Bulk Stations and Terminals"
        },
        {
          code: "424720",
          label: "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)"
        }
      ],
      "Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers": [
        {
          code: "424810",
          label: "Beer and Ale Merchant Wholesalers"
        },
        {
          code: "424820",
          label: "Wine and Distilled Alcoholic Beverage Merchant Wholesalers"
        }
      ],
      "Miscellaneous Nondurable Goods Merchant Wholesalers": [
        {
          code: "424910",
          label: "Farm Supplies Merchant Wholesalers"
        },
        {
          code: "424920",
          label: "Book, Periodical, and Newspaper Merchant Wholesalers"
        },
        {
          code: "424930",
          label: "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers"
        },
        {
          code: "424940",
          label: "Tobacco Product and Electronic Cigarette Merchant Wholesalers"
        },
        {
          code: "424950",
          label: "Paint, Varnish, and Supplies Merchant Wholesalers"
        },
        {
          code: "424990",
          label: "Other Miscellaneous Nondurable Goods Merchant Wholesalers"
        }
      ],
      "Wholesale Trade Agents and Brokers": [
        {
          code: "425120",
          label: "Wholesale Trade Agents and Brokers"
        }
      ]
    },
    "Retail Trade": {
      "Automobile Dealers": [
        { code: "441110", label: "New Car Dealers" },
        { code: "441120", label: "Used Car Dealers" }
      ],
      "Other Motor Vehicle Dealers": [
        { code: "441210", label: "Recreational Vehicle Dealers" },
        { code: "441222", label: "Boat Dealers" },
        {
          code: "441227",
          label: "Motorcycle, ATV, and All Other Motor Vehicle Dealers"
        }
      ],
      "Automotive Parts, Accessories, and Tire Retailers": [
        {
          code: "441330",
          label: "Automotive Parts and Accessories Retailers"
        },
        { code: "441340", label: "Tire Dealers" }
      ],
      "Building Material and Supplies Dealers": [
        { code: "444110", label: "Home Centers" },
        { code: "444120", label: "Paint and Wallpaper Retailers" },
        { code: "444140", label: "Hardware Retailers" },
        {
          code: "444180",
          label: "Other Building Material Dealers"
        }
      ],
      "Lawn and Garden Equipment and Supplies Retailers": [
        {
          code: "444230",
          label: "Outdoor Power Equipment Retailers"
        },
        {
          code: "444240",
          label: "Nursery, Garden Center, and Farm Supply Retailers"
        }
      ],
      "Grocery and Convenience Retailers": [
        {
          code: "445110",
          label: "Supermarkets and Other Grocery Retailers (except Convenience Retailers)"
        },
        { code: "445131", label: "Convenience Retailers" },
        { code: "445132", label: "Vending Machine Operators" }
      ],
      "Specialty Food Retailers": [
        { code: "445230", label: "Fruit and Vegetable Retailers" },
        { code: "445240", label: "Meat Retailers" },
        { code: "445250", label: "Fish and Seafood Retailers" },
        { code: "445291", label: "Baked Goods Retailers" },
        {
          code: "445292",
          label: "Confectionery and Nut Retailers"
        },
        {
          code: "445298",
          label: "All Other Specialty Food Retailers"
        }
      ],
      "Beer, Wine, and Liquor Retailers": [
        {
          code: "445320",
          label: "Beer, Wine, and Liquor Retailers"
        }
      ],
      "Furniture and Home Furnishings Retailers": [
        { code: "449110", label: "Furniture Retailers" },
        { code: "449121", label: "Floor Covering Retailers" },
        { code: "449122", label: "Window Treatment Retailers" },
        {
          code: "449129",
          label: "All Other Home Furnishings Retailers"
        }
      ],
      "Electronics and Appliance Retailers": [
        {
          code: "449210",
          label: "Electronics and Appliance Retailers"
        }
      ],
      "Department Stores": [ { code: "455110", label: "Department Stores" } ],
      "Warehouse Clubs, Supercenters, and Other General Merchandise Retailers": [
        {
          code: "455211",
          label: "Warehouse Clubs and Supercenters"
        },
        {
          code: "455219",
          label: "All Other General Merchandise Retailers"
        }
      ],
      "Health and Personal Care Retailers": [
        { code: "456110", label: "Pharmacies and Drug Retailers" },
        {
          code: "456120",
          label: "Cosmetics, Beauty Supplies, and Perfume Retailers"
        },
        { code: "456130", label: "Optical Goods Retailers" },
        {
          code: "456191",
          label: "Food (Health) Supplement Retailers"
        },
        {
          code: "456199",
          label: "All Other Health and Personal Care Retailers"
        }
      ],
      "Gasoline Stations": [
        {
          code: "457110",
          label: "Gasoline Stations with Convenience Stores"
        },
        { code: "457120", label: "Other Gasoline Stations" }
      ],
      "Fuel Dealers": [ { code: "457210", label: "Fuel Dealers" } ],
      "Clothing and Clothing Accessories Retailers": [
        {
          code: "458110",
          label: "Clothing and Clothing Accessories Retailers"
        }
      ],
      "Shoe Retailers": [ { code: "458210", label: "Shoe Retailers" } ],
      "Jewelry, Luggage, and Leather Goods Retailers": [
        { code: "458310", label: "Jewelry Retailers" },
        {
          code: "458320",
          label: "Luggage and Leather Goods Retailers"
        }
      ],
      "Sporting Goods, Hobby, and Musical Instrument Retailers": [
        { code: "459110", label: "Sporting Goods Retailers" },
        { code: "459120", label: "Hobby, Toy, and Game Retailers" },
        {
          code: "459130",
          label: "Sewing, Needlework, and Piece Goods Retailers"
        },
        {
          code: "459140",
          label: "Musical Instrument and Supplies Retailers"
        }
      ],
      "Book Retailers and News Dealers": [
        {
          code: "459210",
          label: "Book Retailers and News Dealers"
        }
      ],
      Florists: [ { code: "459310", label: "Florists" } ],
      "Office Supplies, Stationery, and Gift Retailers": [
        {
          code: "459410",
          label: "Office Supplies and Stationery Retailers"
        },
        {
          code: "459420",
          label: "Gift, Novelty, and Souvenir Retailers"
        }
      ],
      "Used Merchandise Retailers": [ { code: "459510", label: "Used Merchandise Retailers" } ],
      "Other Miscellaneous Retailers": [
        { code: "459910", label: "Pet and Pet Supplies Retailers" },
        { code: "459920", label: "Art Dealers" },
        {
          code: "459930",
          label: "Manufactured (Mobile) Home Dealers"
        },
        {
          code: "459991",
          label: "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers"
        },
        {
          code: "459999",
          label: "All Other Miscellaneous Retailers"
        }
      ]
    },
    "Transportation and Warehousing": {
      "Scheduled Air Transportation": [
        {
          code: "481111",
          label: "Scheduled Passenger Air Transportation"
        },
        {
          code: "481112",
          label: "Scheduled Freight Air Transportation"
        }
      ],
      "Nonscheduled Air Transportation": [
        {
          code: "481211",
          label: "Nonscheduled Chartered Passenger Air Transportation"
        },
        {
          code: "481212",
          label: "Nonscheduled Chartered Freight Air Transportation"
        },
        {
          code: "481219",
          label: "Other Nonscheduled Air Transportation"
        }
      ],
      "Rail Transportation": [
        { code: "482111", label: "Line-Haul Railroads" },
        { code: "482112", label: "Short Line Railroads" }
      ],
      "Deep Sea, Coastal, and Great Lakes Water Transportation": [
        {
          code: "483111",
          label: "Deep Sea Freight Transportation"
        },
        {
          code: "483112",
          label: "Deep Sea Passenger Transportation"
        },
        {
          code: "483113",
          label: "Coastal and Great Lakes Freight Transportation"
        },
        {
          code: "483114",
          label: "Coastal and Great Lakes Passenger Transportation"
        }
      ],
      "Inland Water Transportation": [
        {
          code: "483211",
          label: "Inland Water Freight Transportation"
        },
        {
          code: "483212",
          label: "Inland Water Passenger Transportation"
        }
      ],
      "General Freight Trucking": [
        {
          code: "484110",
          label: "General Freight Trucking, Local"
        },
        {
          code: "484121",
          label: "General Freight Trucking, Long-Distance, Truckload"
        },
        {
          code: "484122",
          label: "General Freight Trucking, Long-Distance, Less Than Truckload"
        }
      ],
      "Specialized Freight Trucking": [
        {
          code: "484210",
          label: "Used Household and Office Goods Moving"
        },
        {
          code: "484220",
          label: "Specialized Freight (except Used Goods) Trucking, Local"
        },
        {
          code: "484230",
          label: "Specialized Freight (except Used Goods) Trucking, Long-Distance"
        }
      ],
      "Urban Transit Systems": [
        { code: "485111", label: "Mixed Mode Transit Systems" },
        { code: "485112", label: "Commuter Rail Systems" },
        {
          code: "485113",
          label: "Bus and Other Motor Vehicle Transit Systems"
        },
        { code: "485119", label: "Other Urban Transit Systems" }
      ],
      "Interurban and Rural Bus Transportation": [
        {
          code: "485210",
          label: "Interurban and Rural Bus Transportation"
        }
      ],
      "Taxi and Limousine Service": [
        { code: "485310", label: "Taxi and Ridesharing Services" },
        { code: "485320", label: "Limousine Service" }
      ],
      "School and Employee Bus Transportation": [
        {
          code: "485410",
          label: "School and Employee Bus Transportation"
        }
      ],
      "Charter Bus Industry": [ { code: "485510", label: "Charter Bus Industry" } ],
      "Other Transit and Ground Passenger Transportation": [
        { code: "485991", label: "Special Needs Transportation" },
        {
          code: "485999",
          label: "All Other Transit and Ground Passenger Transportation"
        }
      ],
      "Pipeline Transportation of Crude Oil": [
        {
          code: "486110",
          label: "Pipeline Transportation of Crude Oil"
        }
      ],
      "Pipeline Transportation of Natural Gas": [
        {
          code: "486210",
          label: "Pipeline Transportation of Natural Gas"
        }
      ],
      "Other Pipeline Transportation": [
        {
          code: "486910",
          label: "Pipeline Transportation of Refined Petroleum Products"
        },
        {
          code: "486990",
          label: "All Other Pipeline Transportation"
        }
      ],
      "Scenic and Sightseeing Transportation, Land": [
        {
          code: "487110",
          label: "Scenic and Sightseeing Transportation, Land"
        }
      ],
      "Scenic and Sightseeing Transportation, Water": [
        {
          code: "487210",
          label: "Scenic and Sightseeing Transportation, Water"
        }
      ],
      "Scenic and Sightseeing Transportation, Other": [
        {
          code: "487990",
          label: "Scenic and Sightseeing Transportation, Other"
        }
      ],
      "Support Activities for Air Transportation": [
        { code: "488111", label: "Air Traffic Control" },
        { code: "488119", label: "Other Airport Operations" },
        {
          code: "488190",
          label: "Other Support Activities for Air Transportation"
        }
      ],
      "Support Activities for Rail Transportation": [
        {
          code: "488210",
          label: "Support Activities for Rail Transportation"
        }
      ],
      "Support Activities for Water Transportation": [
        { code: "488310", label: "Port and Harbor Operations" },
        { code: "488320", label: "Marine Cargo Handling" },
        {
          code: "488330",
          label: "Navigational Services to Shipping"
        },
        {
          code: "488390",
          label: "Other Support Activities for Water Transportation"
        }
      ],
      "Support Activities for Road Transportation": [
        { code: "488410", label: "Motor Vehicle Towing" },
        {
          code: "488490",
          label: "Other Support Activities for Road Transportation"
        }
      ],
      "Freight Transportation Arrangement": [
        {
          code: "488510",
          label: "Freight Transportation Arrangement"
        }
      ],
      "Other Support Activities for Transportation": [
        { code: "488991", label: "Packing and Crating" },
        {
          code: "488999",
          label: "All Other Support Activities for Transportation"
        }
      ],
      "Postal Service": [ { code: "491110", label: "Postal Service" } ],
      "Couriers and Express Delivery Services": [
        {
          code: "492110",
          label: "Couriers and Express Delivery Services"
        }
      ],
      "Local Messengers and Local Delivery": [
        {
          code: "492210",
          label: "Local Messengers and Local Delivery"
        }
      ],
      "Warehousing and Storage": [
        {
          code: "493110",
          label: "General Warehousing and Storage"
        },
        {
          code: "493120",
          label: "Refrigerated Warehousing and Storage"
        },
        {
          code: "493130",
          label: "Farm Product Warehousing and Storage"
        },
        { code: "493190", label: "Other Warehousing and Storage" }
      ]
    },
    Information: {
      "Motion Picture and Video Industries": [
        {
          code: "512110",
          label: "Motion Picture and Video Production"
        },
        {
          code: "512120",
          label: "Motion Picture and Video Distribution"
        },
        {
          code: "512131",
          label: "Motion Picture Theaters (except Drive-Ins)"
        },
        {
          code: "512132",
          label: "Drive-In Motion Picture Theaters"
        },
        {
          code: "512191",
          label: "Teleproduction and Other Postproduction Services"
        },
        {
          code: "512199",
          label: "Other Motion Picture and Video Industries"
        }
      ],
      "Sound Recording Industries": [
        { code: "512230", label: "Music Publishers" },
        { code: "512240", label: "Sound Recording Studios" },
        {
          code: "512250",
          label: "Record Production and Distribution"
        },
        {
          code: "512290",
          label: "Other Sound Recording Industries"
        }
      ],
      "Newspaper, Periodical, Book, and Directory Publishers": [
        { code: "513110", label: "Newspaper Publishers" },
        { code: "513120", label: "Periodical Publishers" },
        { code: "513130", label: "Book Publishers" },
        {
          code: "513140",
          label: "Directory and Mailing List Publishers"
        },
        { code: "513191", label: "Greeting Card Publishers" },
        { code: "513199", label: "All Other Publishers" }
      ],
      "Software Publishers": [ { code: "513210", label: "Software Publishers" } ],
      "Radio and Television Broadcasting Stations": [
        { code: "516110", label: "Radio Broadcasting Stations" },
        {
          code: "516120",
          label: "Television Broadcasting Stations"
        }
      ],
      "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers": [
        {
          code: "516210",
          label: "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers"
        }
      ],
      "Wired and Wireless Telecommunications (except Satellite)": [
        {
          code: "517111",
          label: "Wired Telecommunications Carriers"
        },
        {
          code: "517112",
          label: "Wireless Telecommunications Carriers (except Satellite)"
        },
        { code: "517121", label: "Telecommunications Resellers" },
        {
          code: "517122",
          label: "Agents for Wireless Telecommunications Services"
        }
      ],
      "Satellite Telecommunications": [ { code: "517410", label: "Satellite Telecommunications" } ],
      "All Other Telecommunications": [ { code: "517810", label: "All Other Telecommunications" } ],
      "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services": [
        {
          code: "518210",
          label: "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services"
        }
      ],
      "Web Search Portals, Libraries, Archives, and Other Information Services": [
        { code: "519210", label: "Libraries and Archives" },
        {
          code: "519290",
          label: "Web Search Portals and All Other Information Services"
        }
      ]
    },
    "Finance and Insurance": {
      "Monetary Authorities-Central Bank": [
        {
          code: "521110",
          label: "Monetary Authorities-Central Bank"
        }
      ],
      "Depository Credit Intermediation": [
        { code: "522110", label: "Commercial Banking" },
        { code: "522130", label: "Credit Unions" },
        {
          code: "522180",
          label: "Savings Institutions and Other Depository Credit Intermediation"
        }
      ],
      "Nondepository Credit Intermediation": [
        { code: "522210", label: "Credit Card Issuing" },
        { code: "522220", label: "Sales Financing" },
        { code: "522291", label: "Consumer Lending" },
        { code: "522292", label: "Real Estate Credit" },
        {
          code: "522299",
          label: "International, Secondary Market, and All Other Nondepository Credit Intermediation"
        }
      ],
      "Activities Related to Credit Intermediation": [
        {
          code: "522310",
          label: "Mortgage and Nonmortgage Loan Brokers"
        },
        {
          code: "522320",
          label: "Financial Transactions Processing, Reserve, and Clearinghouse Activities"
        },
        {
          code: "522390",
          label: "Other Activities Related to Credit Intermediation"
        }
      ],
      "Securities and Commodity Contracts Intermediation and Brokerage": [
        {
          code: "523150",
          label: "Investment Banking and Securities Intermediation"
        },
        {
          code: "523160",
          label: "Commodity Contracts Intermediation"
        }
      ],
      "Securities and Commodity Exchanges": [
        {
          code: "523210",
          label: "Securities and Commodity Exchanges"
        }
      ],
      "Other Financial Investment Activities": [
        { code: "523910", label: "Miscellaneous Intermediation" },
        {
          code: "523940",
          label: "Portfolio Management and Investment Advice"
        },
        {
          code: "523991",
          label: "Trust, Fiduciary, and Custody Activities"
        },
        {
          code: "523999",
          label: "Miscellaneous Financial Investment Activities"
        }
      ],
      "Insurance Carriers": [
        { code: "524113", label: "Direct Life Insurance Carriers" },
        {
          code: "524114",
          label: "Direct Health and Medical Insurance Carriers"
        },
        {
          code: "524126",
          label: "Direct Property and Casualty Insurance Carriers"
        },
        {
          code: "524127",
          label: "Direct Title Insurance Carriers"
        },
        {
          code: "524128",
          label: "Other Direct Insurance (except Life, Health, and Medical) Carriers"
        },
        { code: "524130", label: "Reinsurance Carriers" }
      ],
      "Agencies, Brokerages, and Other Insurance Related Activities": [
        {
          code: "524210",
          label: "Insurance Agencies and Brokerages"
        },
        { code: "524291", label: "Claims Adjusting" },
        {
          code: "524292",
          label: "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds"
        },
        {
          code: "524298",
          label: "All Other Insurance Related Activities"
        }
      ],
      "Insurance and Employee Benefit Funds": [
        { code: "525110", label: "Pension Funds" },
        { code: "525120", label: "Health and Welfare Funds" },
        { code: "525190", label: "Other Insurance Funds" }
      ],
      "Other Investment Pools and Funds": [
        { code: "525910", label: "Open-End Investment Funds" },
        {
          code: "525920",
          label: "Trusts, Estates, and Agency Accounts"
        },
        { code: "525990", label: "Other Financial Vehicles" }
      ]
    },
    "Real Estate and Rental and Leasing": {
      "Lessors of Real Estate": [
        {
          code: "531110",
          label: "Lessors of Residential Buildings and Dwellings"
        },
        {
          code: "531120",
          label: "Lessors of Nonresidential Buildings (except Miniwarehouses)"
        },
        {
          code: "531130",
          label: "Lessors of Miniwarehouses and Self-Storage Units"
        },
        {
          code: "531190",
          label: "Lessors of Other Real Estate Property"
        }
      ],
      "Offices of Real Estate Agents and Brokers": [
        {
          code: "531210",
          label: "Offices of Real Estate Agents and Brokers"
        }
      ],
      "Activities Related to Real Estate": [
        { code: "531311", label: "Residential Property Managers" },
        {
          code: "531312",
          label: "Nonresidential Property Managers"
        },
        {
          code: "531320",
          label: "Offices of Real Estate Appraisers"
        },
        {
          code: "531390",
          label: "Other Activities Related to Real Estate"
        }
      ],
      "Automotive Equipment Rental and Leasing": [
        { code: "532111", label: "Passenger Car Rental" },
        { code: "532112", label: "Passenger Car Leasing" },
        {
          code: "532120",
          label: "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing"
        }
      ],
      "Consumer Goods Rental": [
        {
          code: "532210",
          label: "Consumer Electronics and Appliances Rental"
        },
        { code: "532281", label: "Formal Wear and Costume Rental" },
        { code: "532282", label: "Video Tape and Disc Rental" },
        { code: "532283", label: "Home Health Equipment Rental" },
        { code: "532284", label: "Recreational Goods Rental" },
        {
          code: "532289",
          label: "All Other Consumer Goods Rental"
        }
      ],
      "General Rental Centers": [ { code: "532310", label: "General Rental Centers" } ],
      "Commercial and Industrial Machinery and Equipment Rental and Leasing": [
        {
          code: "532411",
          label: "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing"
        },
        {
          code: "532412",
          label: "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing"
        },
        {
          code: "532420",
          label: "Office Machinery and Equipment Rental and Leasing"
        },
        {
          code: "532490",
          label: "Other Commercial and Industrial Machinery and Equipment Rental and Leasing"
        }
      ],
      "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)": [
        {
          code: "533110",
          label: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)"
        }
      ]
    },
    "Professional, Scientific, and Technical Services": {
      "Legal Services": [
        { code: "541110", label: "Offices of Lawyers" },
        { code: "541120", label: "Offices of Notaries" },
        {
          code: "541191",
          label: "Title Abstract and Settlement Offices"
        },
        { code: "541199", label: "All Other Legal Services" }
      ],
      "Accounting, Tax Preparation, Bookkeeping, and Payroll Services": [
        {
          code: "541211",
          label: "Offices of Certified Public Accountants"
        },
        { code: "541213", label: "Tax Preparation Services" },
        { code: "541214", label: "Payroll Services" },
        { code: "541219", label: "Other Accounting Services" }
      ],
      "Architectural, Engineering, and Related Services": [
        { code: "541310", label: "Architectural Services" },
        {
          code: "541320",
          label: "Landscape Architectural Services"
        },
        { code: "541330", label: "Engineering Services" },
        { code: "541340", label: "Drafting Services" },
        { code: "541350", label: "Building Inspection Services" },
        {
          code: "541360",
          label: "Geophysical Surveying and Mapping Services"
        },
        {
          code: "541370",
          label: "Surveying and Mapping (except Geophysical) Services"
        },
        {
          code: "541380",
          label: "Testing Laboratories and Services"
        }
      ],
      "Specialized Design Services": [
        { code: "541410", label: "Interior Design Services" },
        { code: "541420", label: "Industrial Design Services" },
        { code: "541430", label: "Graphic Design Services" },
        {
          code: "541490",
          label: "Other Specialized Design Services"
        }
      ],
      "Computer Systems Design and Related Services": [
        {
          code: "541511",
          label: "Custom Computer Programming Services"
        },
        {
          code: "541512",
          label: "Computer Systems Design Services"
        },
        {
          code: "541513",
          label: "Computer Facilities Management Services"
        },
        {
          code: "541519",
          label: "Other Computer Related Services"
        }
      ],
      "Management, Scientific, and Technical Consulting Services": [
        {
          code: "541611",
          label: "Administrative Management and General Management Consulting Services"
        },
        {
          code: "541612",
          label: "Human Resources Consulting Services"
        },
        { code: "541613", label: "Marketing Consulting Services" },
        {
          code: "541614",
          label: "Process, Physical Distribution, and Logistics Consulting Services"
        },
        {
          code: "541618",
          label: "Other Management Consulting Services"
        },
        {
          code: "541620",
          label: "Environmental Consulting Services"
        },
        {
          code: "541690",
          label: "Other Scientific and Technical Consulting Services"
        }
      ],
      "Scientific Research and Development Services": [
        {
          code: "541713",
          label: "Research and Development in Nanotechnology"
        },
        {
          code: "541714",
          label: "Research and Development in Biotechnology (except Nanobiotechnology)"
        },
        {
          code: "541715",
          label: "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)"
        },
        {
          code: "541720",
          label: "Research and Development in the Social Sciences and Humanities"
        }
      ],
      "Advertising, Public Relations, and Related Services": [
        { code: "541810", label: "Advertising Agencies" },
        { code: "541820", label: "Public Relations Agencies" },
        { code: "541830", label: "Media Buying Agencies" },
        { code: "541840", label: "Media Representatives" },
        {
          code: "541850",
          label: "Indoor and Outdoor Display Advertising"
        },
        { code: "541860", label: "Direct Mail Advertising" },
        {
          code: "541870",
          label: "Advertising Material Distribution Services"
        },
        {
          code: "541890",
          label: "Other Services Related to Advertising"
        }
      ],
      "Other Professional, Scientific, and Technical Services": [
        {
          code: "541910",
          label: "Marketing Research and Public Opinion Polling"
        },
        { code: "541921", label: "Photography Studios, Portrait" },
        { code: "541922", label: "Commercial Photography" },
        {
          code: "541930",
          label: "Translation and Interpretation Services"
        },
        { code: "541940", label: "Veterinary Services" },
        {
          code: "541990",
          label: "All Other Professional, Scientific, and Technical Services"
        }
      ]
    },
    "Management of Companies and Enterprises": {
      "Management of Companies and Enterprises": [
        {
          code: "551111",
          label: "Offices of Bank Holding Companies"
        },
        {
          code: "551112",
          label: "Offices of Other Holding Companies"
        },
        {
          code: "551114",
          label: "Corporate, Subsidiary, and Regional Managing Offices"
        }
      ]
    },
    "Administrative and Support and Waste Management and Remediation Services": {
      "Office Administrative Services": [
        { code: "561110", label: "Office Administrative Services" }
      ],
      "Facilities Support Services": [ { code: "561210", label: "Facilities Support Services" } ],
      "Employment Services": [
        { code: "561311", label: "Employment Placement Agencies" },
        { code: "561312", label: "Executive Search Services" },
        { code: "561320", label: "Temporary Help Services" },
        {
          code: "561330",
          label: "Professional Employer Organizations"
        }
      ],
      "Business Support Services": [
        { code: "561410", label: "Document Preparation Services" },
        { code: "561421", label: "Telephone Answering Services" },
        {
          code: "561422",
          label: "Telemarketing Bureaus and Other Contact Centers"
        },
        { code: "561431", label: "Private Mail Centers" },
        {
          code: "561439",
          label: "Other Business Service Centers (including Copy Shops)"
        },
        { code: "561440", label: "Collection Agencies" },
        { code: "561450", label: "Credit Bureaus" },
        { code: "561491", label: "Repossession Services" },
        {
          code: "561492",
          label: "Court Reporting and Stenotype Services"
        },
        {
          code: "561499",
          label: "All Other Business Support Services"
        }
      ],
      "Travel Arrangement and Reservation Services": [
        { code: "561510", label: "Travel Agencies" },
        { code: "561520", label: "Tour Operators" },
        {
          code: "561591",
          label: "Convention and Visitors Bureaus"
        },
        {
          code: "561599",
          label: "All Other Travel Arrangement and Reservation Services"
        }
      ],
      "Investigation and Security Services": [
        {
          code: "561611",
          label: "Investigation and Personal Background Check Services"
        },
        {
          code: "561612",
          label: "Security Guards and Patrol Services"
        },
        { code: "561613", label: "Armored Car Services" },
        {
          code: "561621",
          label: "Security Systems Services (except Locksmiths)"
        },
        { code: "561622", label: "Locksmiths" }
      ],
      "Services to Buildings and Dwellings": [
        {
          code: "561710",
          label: "Exterminating and Pest Control Services"
        },
        { code: "561720", label: "Janitorial Services" },
        { code: "561730", label: "Landscaping Services" },
        {
          code: "561740",
          label: "Carpet and Upholstery Cleaning Services"
        },
        {
          code: "561790",
          label: "Other Services to Buildings and Dwellings"
        }
      ],
      "Other Support Services": [
        {
          code: "561910",
          label: "Packaging and Labeling Services"
        },
        {
          code: "561920",
          label: "Convention and Trade Show Organizers"
        },
        { code: "561990", label: "All Other Support Services" }
      ],
      "Waste Collection": [
        { code: "562111", label: "Solid Waste Collection" },
        { code: "562112", label: "Hazardous Waste Collection" },
        { code: "562119", label: "Other Waste Collection" }
      ],
      "Waste Treatment and Disposal": [
        {
          code: "562211",
          label: "Hazardous Waste Treatment and Disposal"
        },
        { code: "562212", label: "Solid Waste Landfill" },
        {
          code: "562213",
          label: "Solid Waste Combustors and Incinerators"
        },
        {
          code: "562219",
          label: "Other Nonhazardous Waste Treatment and Disposal"
        }
      ],
      "Remediation and Other Waste Management Services": [
        { code: "562910", label: "Remediation Services" },
        { code: "562920", label: "Materials Recovery Facilities" },
        {
          code: "562991",
          label: "Septic Tank and Related Services"
        },
        {
          code: "562998",
          label: "All Other Miscellaneous Waste Management Services"
        }
      ]
    },
    "Educational Services": {
      "Elementary and Secondary Schools": [
        {
          code: "611110",
          label: "Elementary and Secondary Schools"
        }
      ],
      "Junior Colleges": [ { code: "611210", label: "Junior Colleges" } ],
      "Colleges, Universities, and Professional Schools": [
        {
          code: "611310",
          label: "Colleges, Universities, and Professional Schools"
        }
      ],
      "Business Schools and Computer and Management Training": [
        {
          code: "611410",
          label: "Business and Secretarial Schools"
        },
        { code: "611420", label: "Computer Training" },
        {
          code: "611430",
          label: "Professional and Management Development Training"
        }
      ],
      "Technical and Trade Schools": [
        { code: "611511", label: "Cosmetology and Barber Schools" },
        { code: "611512", label: "Flight Training" },
        { code: "611513", label: "Apprenticeship Training" },
        {
          code: "611519",
          label: "Other Technical and Trade Schools"
        }
      ],
      "Other Schools and Instruction": [
        { code: "611610", label: "Fine Arts Schools" },
        {
          code: "611620",
          label: "Sports and Recreation Instruction"
        },
        { code: "611630", label: "Language Schools" },
        { code: "611691", label: "Exam Preparation and Tutoring" },
        { code: "611692", label: "Automobile Driving Schools" },
        {
          code: "611699",
          label: "All Other Miscellaneous Schools and Instruction"
        }
      ],
      "Educational Support Services": [ { code: "611710", label: "Educational Support Services" } ]
    },
    "Health Care and Social Assistance": {
      "Offices of Physicians": [
        {
          code: "621111",
          label: "Offices of Physicians (except Mental Health Specialists)"
        },
        {
          code: "621112",
          label: "Offices of Physicians, Mental Health Specialists"
        }
      ],
      "Offices of Dentists": [ { code: "621210", label: "Offices of Dentists" } ],
      "Offices of Other Health Practitioners": [
        { code: "621310", label: "Offices of Chiropractors" },
        { code: "621320", label: "Offices of Optometrists" },
        {
          code: "621330",
          label: "Offices of Mental Health Practitioners (except Physicians)"
        },
        {
          code: "621340",
          label: "Offices of Physical, Occupational and Speech Therapists, and Audiologists"
        },
        { code: "621391", label: "Offices of Podiatrists" },
        {
          code: "621399",
          label: "Offices of All Other Miscellaneous Health Practitioners"
        }
      ],
      "Outpatient Care Centers": [
        { code: "621410", label: "Family Planning Centers" },
        {
          code: "621420",
          label: "Outpatient Mental Health and Substance Abuse Centers"
        },
        { code: "621491", label: "HMO Medical Centers" },
        { code: "621492", label: "Kidney Dialysis Centers" },
        {
          code: "621493",
          label: "Freestanding Ambulatory Surgical and Emergency Centers"
        },
        {
          code: "621498",
          label: "All Other Outpatient Care Centers"
        }
      ],
      "Medical and Diagnostic Laboratories": [
        { code: "621511", label: "Medical Laboratories" },
        { code: "621512", label: "Diagnostic Imaging Centers" }
      ],
      "Home Health Care Services": [ { code: "621610", label: "Home Health Care Services" } ],
      "Other Ambulatory Health Care Services": [
        { code: "621910", label: "Ambulance Services" },
        { code: "621991", label: "Blood and Organ Banks" },
        {
          code: "621999",
          label: "All Other Miscellaneous Ambulatory Health Care Services"
        }
      ],
      "General Medical and Surgical Hospitals": [
        {
          code: "622110",
          label: "General Medical and Surgical Hospitals"
        }
      ],
      "Psychiatric and Substance Abuse Hospitals": [
        {
          code: "622210",
          label: "Psychiatric and Substance Abuse Hospitals"
        }
      ],
      "Specialty (except Psychiatric and Substance Abuse) Hospitals": [
        {
          code: "622310",
          label: "Specialty (except Psychiatric and Substance Abuse) Hospitals"
        }
      ],
      "Nursing Care Facilities (Skilled Nursing Facilities)": [
        {
          code: "623110",
          label: "Nursing Care Facilities (Skilled Nursing Facilities)"
        }
      ],
      "Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities": [
        {
          code: "623210",
          label: "Residential Intellectual and Developmental Disability Facilities"
        },
        {
          code: "623220",
          label: "Residential Mental Health and Substance Abuse Facilities"
        }
      ],
      "Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly": [
        {
          code: "623311",
          label: "Continuing Care Retirement Communities"
        },
        {
          code: "623312",
          label: "Assisted Living Facilities for the Elderly"
        }
      ],
      "Other Residential Care Facilities": [
        {
          code: "623990",
          label: "Other Residential Care Facilities"
        }
      ],
      "Individual and Family Services": [
        { code: "624110", label: "Child and Youth Services" },
        {
          code: "624120",
          label: "Services for the Elderly and Persons with Disabilities"
        },
        {
          code: "624190",
          label: "Other Individual and Family Services"
        }
      ],
      "Community Food and Housing, and Emergency and Other Relief Services": [
        { code: "624210", label: "Community Food Services" },
        { code: "624221", label: "Temporary Shelters" },
        {
          code: "624229",
          label: "Other Community Housing Services"
        },
        {
          code: "624230",
          label: "Emergency and Other Relief Services"
        }
      ],
      "Vocational Rehabilitation Services": [
        {
          code: "624310",
          label: "Vocational Rehabilitation Services"
        }
      ],
      "Child Care Services": [ { code: "624410", label: "Child Care Services" } ]
    },
    "Arts, Entertainment, and Recreation": {
      "Performing Arts Companies": [
        {
          code: "711110",
          label: "Theater Companies and Dinner Theaters"
        },
        { code: "711120", label: "Dance Companies" },
        { code: "711130", label: "Musical Groups and Artists" },
        {
          code: "711190",
          label: "Other Performing Arts Companies"
        }
      ],
      "Spectator Sports": [
        { code: "711211", label: "Sports Teams and Clubs" },
        { code: "711212", label: "Racetracks" },
        { code: "711219", label: "Other Spectator Sports" }
      ],
      "Promoters of Performing Arts, Sports, and Similar Events": [
        {
          code: "711310",
          label: "Promoters of Performing Arts, Sports, and Similar Events with Facilities"
        },
        {
          code: "711320",
          label: "Promoters of Performing Arts, Sports, and Similar Events without Facilities"
        }
      ],
      "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures": [
        {
          code: "711410",
          label: "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures"
        }
      ],
      "Independent Artists, Writers, and Performers": [
        {
          code: "711510",
          label: "Independent Artists, Writers, and Performers"
        }
      ],
      "Museums, Historical Sites, and Similar Institutions": [
        { code: "712110", label: "Museums" },
        { code: "712120", label: "Historical Sites" },
        { code: "712130", label: "Zoos and Botanical Gardens" },
        {
          code: "712190",
          label: "Nature Parks and Other Similar Institutions"
        }
      ],
      "Amusement Parks and Arcades": [
        { code: "713110", label: "Amusement and Theme Parks" },
        { code: "713120", label: "Amusement Arcades" }
      ],
      "Gambling Industries": [
        { code: "713210", label: "Casinos (except Casino Hotels)" },
        { code: "713290", label: "Other Gambling Industries" }
      ],
      "Other Amusement and Recreation Industries": [
        { code: "713910", label: "Golf Courses and Country Clubs" },
        { code: "713920", label: "Skiing Facilities" },
        { code: "713930", label: "Marinas" },
        {
          code: "713940",
          label: "Fitness and Recreational Sports Centers"
        },
        { code: "713950", label: "Bowling Centers" },
        {
          code: "713990",
          label: "All Other Amusement and Recreation Industries"
        }
      ]
    },
    "Accommodation and Food Services": {
      "Traveler Accommodation": [
        {
          code: "721110",
          label: "Hotels (except Casino Hotels) and Motels"
        },
        { code: "721120", label: "Casino Hotels" },
        { code: "721191", label: "Bed-and-Breakfast Inns" },
        {
          code: "721199",
          label: "All Other Traveler Accommodation"
        }
      ],
      "RV (Recreational Vehicle) Parks and Recreational Camps": [
        {
          code: "721211",
          label: "RV (Recreational Vehicle) Parks and Campgrounds"
        },
        {
          code: "721214",
          label: "Recreational and Vacation Camps (except Campgrounds)"
        }
      ],
      "Rooming and Boarding Houses, Dormitories, and Workers' Camps": [
        {
          code: "721310",
          label: "Rooming and Boarding Houses, Dormitories, and Workers' Camps"
        }
      ],
      "Special Food Services": [
        { code: "722310", label: "Food Service Contractors" },
        { code: "722320", label: "Caterers" },
        { code: "722330", label: "Mobile Food Services" }
      ],
      "Drinking Places (Alcoholic Beverages)": [
        {
          code: "722410",
          label: "Drinking Places (Alcoholic Beverages)"
        }
      ],
      "Restaurants and Other Eating Places": [
        { code: "722511", label: "Full-Service Restaurants" },
        { code: "722513", label: "Limited-Service Restaurants" },
        {
          code: "722514",
          label: "Cafeterias, Grill Buffets, and Buffets"
        },
        {
          code: "722515",
          label: "Snack and Nonalcoholic Beverage Bars"
        }
      ]
    },
    "Other Services (except Public Administration)": {
      "Automotive Repair and Maintenance": [
        { code: "811111", label: "General Automotive Repair" },
        { code: "811114", label: "Specialized Automotive Repair" },
        {
          code: "811121",
          label: "Automotive Body, Paint, and Interior Repair and Maintenance"
        },
        {
          code: "811122",
          label: "Automotive Glass Replacement Shops"
        },
        {
          code: "811191",
          label: "Automotive Oil Change and Lubrication Shops"
        },
        { code: "811192", label: "Car Washes" },
        {
          code: "811198",
          label: "All Other Automotive Repair and Maintenance"
        }
      ],
      "Electronic and Precision Equipment Repair and Maintenance": [
        {
          code: "811210",
          label: "Electronic and Precision Equipment Repair and Maintenance"
        }
      ],
      "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance": [
        {
          code: "811310",
          label: "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance"
        }
      ],
      "Personal and Household Goods Repair and Maintenance": [
        {
          code: "811411",
          label: "Home and Garden Equipment Repair and Maintenance"
        },
        {
          code: "811412",
          label: "Appliance Repair and Maintenance"
        },
        {
          code: "811420",
          label: "Reupholstery and Furniture Repair"
        },
        {
          code: "811430",
          label: "Footwear and Leather Goods Repair"
        },
        {
          code: "811490",
          label: "Other Personal and Household Goods Repair and Maintenance"
        }
      ],
      "Personal Care Services": [
        { code: "812111", label: "Barber Shops" },
        { code: "812112", label: "Beauty Salons" },
        { code: "812113", label: "Nail Salons" },
        {
          code: "812191",
          label: "Diet and Weight Reducing Centers"
        },
        { code: "812199", label: "Other Personal Care Services" }
      ],
      "Death Care Services": [
        {
          code: "812210",
          label: "Funeral Homes and Funeral Services"
        },
        { code: "812220", label: "Cemeteries and Crematories" }
      ],
      "Drycleaning and Laundry Services": [
        {
          code: "812310",
          label: "Coin-Operated Laundries and Drycleaners"
        },
        {
          code: "812320",
          label: "Drycleaning and Laundry Services (except Coin-Operated)"
        },
        { code: "812331", label: "Linen Supply" },
        { code: "812332", label: "Industrial Launderers" }
      ],
      "Other Personal Services": [
        {
          code: "812910",
          label: "Pet Care (except Veterinary) Services"
        },
        {
          code: "812921",
          label: "Photofinishing Laboratories (except One-Hour)"
        },
        { code: "812922", label: "One-Hour Photofinishing" },
        { code: "812930", label: "Parking Lots and Garages" },
        { code: "812990", label: "All Other Personal Services" }
      ],
      "Religious Organizations": [ { code: "813110", label: "Religious Organizations" } ],
      "Grantmaking and Giving Services": [
        { code: "813211", label: "Grantmaking Foundations" },
        { code: "813212", label: "Voluntary Health Organizations" },
        {
          code: "813219",
          label: "Other Grantmaking and Giving Services"
        }
      ],
      "Social Advocacy Organizations": [
        { code: "813311", label: "Human Rights Organizations" },
        {
          code: "813312",
          label: "Environment, Conservation and Wildlife Organizations"
        },
        {
          code: "813319",
          label: "Other Social Advocacy Organizations"
        }
      ],
      "Civic and Social Organizations": [
        { code: "813410", label: "Civic and Social Organizations" }
      ],
      "Business, Professional, Labor, Political, and Similar Organizations": [
        { code: "813910", label: "Business Associations" },
        { code: "813920", label: "Professional Organizations" },
        {
          code: "813930",
          label: "Labor Unions and Similar Labor Organizations"
        },
        { code: "813940", label: "Political Organizations" },
        {
          code: "813990",
          label: "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)"
        }
      ],
      "Private Households": [ { code: "814110", label: "Private Households" } ]
    },
    "Public Administration": {
      "Executive, Legislative, and Other General Government Support": [
        { code: "921110", label: "Executive Offices" },
        { code: "921120", label: "Legislative Bodies" },
        { code: "921130", label: "Public Finance Activities" },
        {
          code: "921140",
          label: "Executive and Legislative Offices, Combined"
        },
        {
          code: "921150",
          label: "American Indian and Alaska Native Tribal Governments"
        },
        {
          code: "921190",
          label: "Other General Government Support"
        }
      ],
      "Justice, Public Order, and Safety Activities": [
        { code: "922110", label: "Courts" },
        { code: "922120", label: "Police Protection" },
        { code: "922130", label: "Legal Counsel and Prosecution" },
        { code: "922140", label: "Correctional Institutions" },
        {
          code: "922150",
          label: "Parole Offices and Probation Offices"
        },
        { code: "922160", label: "Fire Protection" },
        {
          code: "922190",
          label: "Other Justice, Public Order, and Safety Activities"
        }
      ],
      "Administration of Human Resource Programs": [
        {
          code: "923110",
          label: "Administration of Education Programs"
        },
        {
          code: "923120",
          label: "Administration of Public Health Programs"
        },
        {
          code: "923130",
          label: "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)"
        },
        {
          code: "923140",
          label: "Administration of Veterans' Affairs"
        }
      ],
      "Administration of Environmental Quality Programs": [
        {
          code: "924110",
          label: "Administration of Air and Water Resource and Solid Waste Management Programs"
        },
        {
          code: "924120",
          label: "Administration of Conservation Programs"
        }
      ],
      "Administration of Housing Programs, Urban Planning, and Community Development": [
        {
          code: "925110",
          label: "Administration of Housing Programs"
        },
        {
          code: "925120",
          label: "Administration of Urban Planning and Community and Rural Development"
        }
      ],
      "Administration of Economic Programs": [
        {
          code: "926110",
          label: "Administration of General Economic Programs"
        },
        {
          code: "926120",
          label: "Regulation and Administration of Transportation Programs"
        },
        {
          code: "926130",
          label: "Regulation and Administration of Communications, Electric, Gas, and Other Utilities"
        },
        {
          code: "926140",
          label: "Regulation of Agricultural Marketing and Commodities"
        },
        {
          code: "926150",
          label: "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors"
        }
      ],
      "Space Research and Technology": [
        { code: "927110", label: "Space Research and Technology" }
      ],
      "National Security and International Affairs": [
        { code: "928110", label: "National Security" },
        { code: "928120", label: "International Affairs" }
      ]
    }
  }
  